<template>
  <a-button
    type="text"
    @click="
      handleShowModal();
      $emit('click');
    "
    :disabled="item.status === 2"
    :class="item.status === 2 ? 'button-result-edit' : ''"
  >
    <template #icon>
      <EditOutlined />
    </template>

    Editar resultado
  </a-button>

  <a-drawer
    :visible="visible"
    :title="`Editar resultado - ${item.name}`"
    width="400px"
    :mask-closable="false"
    centered
    :keyboard="false"
    @close="handleConfirmationClose"
  >
    <typification-edit-warning />

    <div class="title">
      <h4>Grupo:</h4>
      <h5>{{ itemgroup.name }}</h5>
    </div>

    <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
      <a-form-item label="Nombre del resultado" name="name">
        <a-input
          v-model:value="formState.name"
          placeholder="Escribir nombre del resultado aquí..."
        />
      </a-form-item>

      <a-form-item name="code">
        <template #label>
          <span class="label">
            Código de integración
            <a-tooltip>
              <template v-slot:title>
                Código de identificación para exportaciones o integraciones
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </span>
        </template>
        <a-input v-model:value="formState.code" placeholder="Escribir código aquí..." />
      </a-form-item>
    </a-form>

    <fixed-footer
      confirmText="Editar resultado"
      @onCancel="handleCancel"
      @onConfirm="handleOk"
      cancelText="Cancelar"
    />
  </a-drawer>
</template>

<script>
import { defineComponent, reactive, ref, toRaw, createVNode } from "vue";
import { InfoCircleOutlined, EditOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import FixedFooter from "@/app/shared/components/sections/FixedFooter.vue";
import TypificationEditWarning from "@/app/entities/components/sections/TypificationEditWarning.vue";
import { Modal } from "ant-design-vue";

export default defineComponent({
  components: {
    InfoCircleOutlined,
    EditOutlined,
    FixedFooter,
    TypificationEditWarning,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
    itemgroup: {
      required: true,
      type: Object,
    },
  },
  setup(props) {
    const formRef = ref();
    const formState = reactive({
      name: props.item.name,
      group_type: props.item.group_type,
      code: props.item.code,
    });
    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
    };

    return {
      formRef,
      formState,
      rules,
    };
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    handleOk() {
      this.formRef.validateFields().then(() => {
        let values = toRaw(this.formState);
        delete this.item.form_id;
        if (this.item.name == values.name) {
          delete values.name;
        }
        this.$emit("change", { ...this.item, ...values, group: this.itemgroup.id });
        this.visible = false;
        this.formRef.resetFields();
      });
    },
    handleShowModal() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Estás seguro de descartar cambios?",
        content: "Al cerrar no se guardarán los datos previamente ingresados",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Descartar",
        cancelText: "Cancelar",
      });
    },
  },
});
</script>

<style lang="sass" scoped>
.title
  margin-bottom: 24px
.button-result-edit
  opacity: 0.4
</style>
